import EventEmitter from 'events/events.js' // forces it to use the module from node_modules
import ms from 'ms'

import WebSocket from '../websocket/index.js'

const RECONNECT_INTERVAL = ms('10s')
const PING_INTERVAL = ms('10s')
const MAX_RECONNECT_DELAY = ms('15s')

export default function createWebSocket(getURL) {
  const addresses = new Set()
  const events = new EventEmitter()
  let ws
  let pingIntervalId = null
  let opened = false
  let isWSOpened = false
  let openTimeoutId

  function subscribeAddress(address) {
    const data = JSON.stringify({ type: 'subscribe-address', address })
    ws.send(data)
  }

  function subscribeGasPrice() {
    const data = JSON.stringify({ type: 'subscribe-gasprice' })
    ws.send(data)
  }

  function clearPing() {
    clearInterval(pingIntervalId)
    pingIntervalId = null
  }

  function onMessage(data) {
    data = JSON.parse(data)
    switch (data.type) {
      case 'address':
        events.emit(`address-${data.address}`)
        break
      case 'gasprice':
        events.emit('gasprice', { gasPrice: data.gasprice, baseFeePerGas: data.baseGasPrice })
        break
    }
  }

  function open() {
    opened = true
    clearTimeout(openTimeoutId)
    if (ws) return

    ws = new WebSocket(getURL())
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onerror = (e) => {}
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onmessage = (e) => {
      try {
        onMessage(e.data)
      } catch {}
    }

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onopen = () => {
      for (const address of addresses.values()) subscribeAddress(address)
      subscribeGasPrice()
      if (typeof ws.ping === 'function') {
        pingIntervalId = setInterval(() => ws.ping(), PING_INTERVAL)
      } else {
        console.warn('Client side ping not available')
      }

      isWSOpened = true
      events.emit('open')
    }

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onclose = () => {
      ws = null
      isWSOpened = false
      clearPing()
      if (opened) {
        openTimeoutId = setTimeout(open, reconnectDelay())
      }

      events.emit('close')
    }
  }

  function close() {
    opened = false
    isWSOpened = false
    clearTimeout(openTimeoutId)
    if (!ws) return
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onerror = null
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onmessage = null
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onopen = null
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    ws.onclose = null
    try {
      ws.close()
    } catch (e) {
      if (!/WebSocket was closed before the connection was established/.test(e.message)) {
        throw e
      }
    }

    ws = null
    clearPing()
    events.emit('close')
  }

  function reconnectDelay() {
    const min = RECONNECT_INTERVAL
    const max = MAX_RECONNECT_DELAY
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  function watch(address) {
    if (addresses.has(address)) return
    addresses.add(address)

    if (ws) subscribeAddress(address)
  }

  return { events, open, close, watch, isCreated: () => !!ws, isOpened: () => isWSOpened }
}
